"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOccupiedTableStatus = void 0;
const domain_1 = require("@oolio-group/domain");
const events_1 = require("./events");
const utils_1 = require("./utils");
const updateOccupiedTableStatus = (event, prevState) => {
    if (events_1.OCCUPIED_TABLE_EVENTS.includes(event.action) &&
        [domain_1.OrderStatus.IN_PROGRESS, domain_1.OrderStatus.ON_HOLD].includes(prevState.status)) {
        // if it is reservation order and no orderItems present, do not update table status
        const getTableStatus = () => {
            var _a;
            return !((_a = prevState === null || prevState === void 0 ? void 0 : prevState.orderItems) === null || _a === void 0 ? void 0 : _a.length)
                ? domain_1.TableStatus.SEATED
                : domain_1.TableStatus.OCCUPIED;
        };
        const updateTableStatus = (table) => (table === null || table === void 0 ? void 0 : table.status) !== domain_1.TableStatus.OCCUPIED &&
            (table === null || table === void 0 ? void 0 : table.status) !== domain_1.TableStatus.DONE_SOON
            ? { ...table, status: getTableStatus() }
            : table;
        const tables = (0, utils_1.getTablesFromOrder)(prevState).map(updateTableStatus);
        return {
            ...prevState,
            table: tables[0],
            tables,
        };
    }
    return prevState;
};
exports.updateOccupiedTableStatus = updateOccupiedTableStatus;
//# sourceMappingURL=updateOccupiedTableStatus.js.map